import { i18n } from 'i18next';

import {Device, DeviceMetaData} from '../types/device';
import {Registration, RegistrationMetaData} from '../types/registrationTypes';

const extractDeviceSerialNumber = (reg: Registration) => (reg?.devices?.items ?? []).map((device) => device.serialNumber).join(',');

const extractDevicesArticleName = (reg: Registration, t: i18n['t'], registrationIsCompleted: boolean) =>
  (reg?.devices?.items ?? []).map((device) => extractDeviceArticleName(device, t, registrationIsCompleted)).join(',');

const extractDeviceArticleName = (device: Device, t: i18n['t'], registrationIsCompleted: boolean) =>
  device.articleName !== '' ? device.articleName : t('registrations.general.missingArticleName');

const extractDeviceSerialNumberFromMetaData = (reg: RegistrationMetaData) => (reg?.devices?.items ?? []).map((device) => device.serialNumber).join(',');

const extractDevicesArticleNameFromMetaData = (reg: RegistrationMetaData, t: i18n['t'], registrationIsCompleted: boolean) =>
  (reg?.devices?.items ?? []).map((device) => extractDeviceArticleNameFromMetaData(device, t, registrationIsCompleted)).join(',');

const extractDeviceArticleNameFromMetaData = (device: DeviceMetaData, t: i18n['t'], registrationIsCompleted: boolean) =>
  device.articleName !== '' ? device.articleName : t('registrations.general.missingArticleName');

export { 
  extractDeviceArticleName, 
  extractDevicesArticleName, 
  extractDeviceSerialNumber,
  extractDeviceArticleNameFromMetaData,
  extractDevicesArticleNameFromMetaData,
  extractDeviceSerialNumberFromMetaData
};

